{
  "version": 1,
  "asset_id": "fd262a78-a9fc-4f64-a8fc-4d3e2cf6f17d",
  "project_id": "530287cc-6277-4c3a-8f0e-1235af941c4b",
  "url": "/__l5e/assets-v1/fd262a78-a9fc-4f64-a8fc-4d3e2cf6f17d/karel-bauer-new.jpg",
  "r2_key": "a/v1/530287cc-6277-4c3a-8f0e-1235af941c4b/fd262a78-a9fc-4f64-a8fc-4d3e2cf6f17d/karel-bauer-new.jpg",
  "original_filename": "karel-bauer-new.jpg",
  "size": 604496,
  "content_type": "image/jpeg",
  "created_at": "2026-06-22T07:32:20Z"
}
